import { useMutation, useQuery } from 'react-query';
import * as storeService from '../services/storeService';
import { CreateSectionDto, CreateStoreDto } from '../types/dto';
import { Section, Store } from '../types/models';
import { ListDto } from '../types/dto/ListDto';

const createStore = async (data: CreateStoreDto) => {
    return await storeService.createStore(data);
}

const getMyStores = async () => {
    return await storeService.getMyStores();
}

const getStoreById = async (storeId: string) => {
    return await storeService.getStoreById(storeId);
}


export const useCreateStore = (onSuccess: any, onError: any) => {
    return useMutation(createStore, {
        onSuccess,
        onError
    });
}

export const useGetMyStores = (options = {}) => {
    return useQuery({
        queryKey: ['myStores'],
        queryFn: getMyStores,
        ...options
    });
}

export const useGetStores = (dto: ListDto, options = {}) => {
    return useQuery({
        queryKey: ['stores', dto],
        queryFn: () => storeService.getStores(dto),
        ...options
    });
}

export const useGetStoreCategoryProducts = (dto: storeService.ListStoreCategoryProductsDto, options = {}) => {
    return useQuery({
        queryKey: ['storeCategoryProducts', dto],
        queryFn: () => storeService.getStoreCategoryProducts(dto),
        ...options
    });
}

export const useUpdateStore = (onSuccess: any, onError: any) => {
    return useMutation(storeService.updateStore, {
        onSuccess,
        onError
    });
}

export const useGetStoreProduct = (storeId: string, storeProductId: string, options = {}) => {
    return useQuery({
        queryKey: ['storeProduct', storeId, storeProductId],
        queryFn: () => storeService.getStoreProduct(storeId, storeProductId),
        ...options
    });
}

export const useGetStoreById =(storeId: string, options = {}) => {
    return useQuery<Store, Error>({
        queryKey: ['store', storeId],
        queryFn: () => getStoreById(storeId),
        enabled: !!storeId,
        ...options
    });
}

